import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-mt-2" }
const _hoisted_2 = { class: "table-header p-d-flex" }
const _hoisted_3 = { class: "p-input-icon-left p-mr-3 p-col-12" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_HierarchyManagementDimensionsInfoDialog = _resolveComponent("HierarchyManagementDimensionsInfoDialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_DataTable, {
      value: _ctx.rows,
      class: "p-datatable-sm kn-table",
      filters: _ctx.filters,
      "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters = $event)),
      globalFilterFields: _ctx.globalFilterFields
    }, {
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
      ]),
      header: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_InputText, {
              class: "kn-material-input",
              modelValue: _ctx.filters['global'].value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
              type: "text",
              placeholder: _ctx.$t('common.search')
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          style: _ctx.hierarchyManagementDimensionsTableDescriptor.smallIconColumn
        }, {
          body: _withCtx((slotProps) => [
            _createVNode("div", {
              class: "pi pi-bars p-button-link",
              draggable: true,
              onDragstart: _withModifiers(($event: any) => (_ctx.onDragStart($event, slotProps.data)), ["stop"])
            }, null, 40, ["onDragstart"])
          ]),
          _: 1
        }, 8, ["style"]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
          return (_openBlock(), _createBlock(_component_Column, {
            class: "kn-truncated",
            header: _ctx.$t(column.header),
            key: column.field,
            sortField: column.field,
            sortable: true
          }, {
            body: _withCtx((slotProps) => [
              _withDirectives(_createVNode("span", {
                class: "kn-cursor-pointer",
                draggable: true,
                onDragstart: ($event: any) => (_ctx.onDragStart($event, slotProps.data))
              }, [
                _createTextVNode(_toDisplayString(slotProps.data[column.field]), 1)
              ], 40, ["onDragstart"]), [
                [
                  _directive_tooltip,
                  slotProps.data[column.field],
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _: 2
          }, 1032, ["header", "sortField"]))
        }), 128)),
        _createVNode(_component_Column, {
          style: _ctx.hierarchyManagementDimensionsTableDescriptor.smallIconColumn
        }, {
          body: _withCtx((slotProps) => [
            _withDirectives(_createVNode(_component_Button, {
              icon: "pi pi-info",
              class: "p-button-link",
              onClick: _withModifiers(($event: any) => (_ctx.showInfo(slotProps.data)), ["stop"])
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                _ctx.$t('common.detail'),
                void 0,
                { top: true }
              ]
            ])
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      _: 1
    }, 8, ["value", "filters", "globalFilterFields"]),
    _createVNode(_component_HierarchyManagementDimensionsInfoDialog, {
      visible: _ctx.infoDialogVisible,
      selectedItem: _ctx.selectedItem,
      onClose: _ctx.closeInfoDialog
    }, null, 8, ["visible", "selectedItem", "onClose"])
  ]))
}